import {
  Component,
  ViewChild,
  ElementRef,
  Input
} from '@angular/core';
import { MediaService } from '../../services/media.service';
import { NgIvsComponent } from '@cotufa82/ng-ivs';
import { Subscription } from 'rxjs';
import Player from 'video.js/dist/types/player';
import { CommonEnums } from '../../../../enums/comman.enums';
import { POST_TYPE_KEY } from 'src/app/constants/constant';
import { ViewChildren, QueryList } from '@angular/core';

@Component({
  selector: 'app-video-player-v3',
  templateUrl: './video-player-v3.component.html',
})
export class VideoPlayerV3Component {
  @ViewChild('trimvideoplayer', { static: true }) trimVideoPlayer: ElementRef;
  @ViewChildren(NgIvsComponent) ivsChildren: QueryList<NgIvsComponent>;

  @Input() post;
  @Input() viewShowAgainInMiddle = false;
  @Input() autoPlay = false;
  @Input() postIndex;
  @Input() totalPosts;
  @Input() videoMode = null;

  player: Player;

  postTypeKey: any = POST_TYPE_KEY;
  commonEnums = CommonEnums;
  startTime = 0;
  endTime = 0;

  showWatchAgainButton = false;
  constructor(private readonly mediaService: MediaService) {}

  ngAfterViewInit() {
    this.ivsChildren.forEach((item) => {
      const player: Player = item.player;
      // if (this.post?.feed_preview_image_url) {
      //   player.poster(this.post.feed_preview_image_url);
      // }
      const src = this.post.video.file;
      let playSub: Subscription;
      player.on('play', () => {
        this.mediaService.pauseRestPlayers(src);
      });
      player.on('pause', () => {
        playSub?.unsubscribe();
      });
    });
  }
  setCoverImage(coverImage) {
    if (coverImage)
      this.ivsChildren.forEach((item) => {
        const player: Player = item.player;
        player.poster(coverImage);
      });
  }

  ngOnDestroy() {
    this.ivsChildren?.forEach((item) => {
      this.mediaService?.intersectionObserver?.unobserve(
        (item as any).elementRef?.nativeElement
      );
    });
  }
}
